module.exports = __webpack_public_path__ + "media/images/c_3-b6d98bf5f1f85faaf611b02be8c5a8b1.png";